import React, { DependencyList, useEffect } from "react";
import * as d3 from "d3";
import { Selection } from "d3-selection";

export const useD3 = (renderChartFn: (svg: Selection<SVGSVGElement, unknown, null, undefined>) => void, dependencies: DependencyList) => {
    const ref = React.useRef<SVGSVGElement>();
    useEffect(() => {
        renderChartFn(d3.select(ref.current));
    }, dependencies);
    return ref;
};
